import { JSX } from 'preact'
import { Provider as StoreProvider } from '@gsc/preact-redux'
import { Store, useAppSelector } from './store/store'
import { WidgetInstance } from './types'
import { Widget } from './components/Widget'

const useWidgetList = (): WidgetInstance[] => {
  const widgets = useAppSelector(state => state.widgets)
  return Object.keys(widgets)
    .map(id => widgets[id])
    .sort((a, b) => (b.sort_order || 0) - (a.sort_order || 0))
}

const WidgetList = (): JSX.Element => {
  const widgets = useWidgetList()
  return (
    <>
      {widgets.map(w => (
        // we use layout as a key here to remount widget completely if it changes
        <Widget widget={w} key={w.id + w.layout} />
      ))}
    </>
  )
}

export interface AppProps {
  store: Store
}

export const App = ({ store }: AppProps): JSX.Element => (
  <StoreProvider store={store}>
    <WidgetList />
  </StoreProvider>
)
